export enum WithdrawRequestStatusEnum {
  PENDING = 'PENDING',
  REJECT = 'REJECT',
  APPROVE = 'APPROVE',
}
